import React from "react";
import "./Blog_inner_content.css";
import  parse  from "html-react-parser";

function Blog_inner_content({blogid}) {
  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return (
    <section className="Blog_inner_content">
      <div className="text_holder">
        <div className="row">
          <div className="col-md-2">
            <div className="meta-info">
              <p className="title">Uploaded Date</p>
              <p className="subtitle">{blogid?.updatedAt ? formatDate(blogid.updatedAt) : "No date available"}</p>
              {/* <p>- {formatDate(date)}</p> */}
            </div>
          </div>
          <div className="col-md-10">
            <h2 className="main-description"> {blogid?.description ? parse(blogid.description) : ""}
            </h2>
          </div>
        </div>
      </div>

      <div className="text_holder mt-4">
        <div className="row">
          <div className="col-md-2">
            <div className="meta-info">
              <p className="title">Category</p>
              <p className="subtitle">Product Guides & Comparisons</p>
            </div>
          </div>
          <div className="col-md-10">
            <div className="list_content_holder">
              <h3 className="section-title">{blogid?.long_description ? parse(blogid.long_description) : ""}</h3>
              {/* <p className="content-text">
                The material of your business card plays a big role in its look
                and feel. Here are some common options:
              </p>
              <ul className="content-list">
                <li>
                  Standard Cardstock (14-16 pt) – Durable, affordable, and
                  widely used for traditional business cards.
                </li>
                <li>
                  Premium Cardstock (18-32 pt) – Thicker and more luxurious,
                  offering a high-end feel.
                </li>
                <li>
                  Textured or Specialty Paper – Adds uniqueness with linen,
                  kraft, or cotton finishes.
                </li>
              </ul> */}
            </div>

            {/* <div className="list_content_holder">
              <h3 className="section-title">2. Decide on a Finish</h3>
              <p className="content-text">
                The material of your business card plays a big role in its look
                and feel. Here are some common options:
              </p>
              <ul className="content-list">
                <li>
                  Standard Cardstock (14-16 pt) – Durable, affordable, and
                  widely used for traditional business cards.
                </li>
                <li>
                  Premium Cardstock (18-32 pt) – Thicker and more luxurious,
                  offering a high-end feel.
                </li>
                <li>
                  Textured or Specialty Paper – Adds uniqueness with linen,
                  kraft, or cotton finishes.
                </li>
              </ul>
            </div> */}

            <div className="Final_Thoughts">
              <div className="list_content_holder">
                <h3 className="section-title">{blogid?.final_thoughts ? parse(blogid.final_thoughts) : ""}</h3>
                {/* <p className="content-text">
                  Your business card is a small but powerful marketing tool. By
                  choosing the right materials, design elements, and finishes,
                  you can create a card that leaves a memorable impression. Take
                  the time to select the best business card for your brand, &
                  you’ll always be prepared to network in style!
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blog_inner_content;
